function hexToRgb(hex) {
  if (!hex) return null;
  const cleanHex = hex.replace('#', '');
  if (cleanHex.length === 3) {
    const r = parseInt(cleanHex.substring(0, 1).repeat(2), 16);
    const g = parseInt(cleanHex.substring(1, 2).repeat(2), 16);
    const b = parseInt(cleanHex.substring(2, 3).repeat(2), 16);
    return { r, g, b };
  } else if (cleanHex.length === 6) {
    const r = parseInt(cleanHex.substring(0, 2), 16);
    const g = parseInt(cleanHex.substring(2, 4), 16);
    const b = parseInt(cleanHex.substring(4, 6), 16);
    return { r, g, b };
  }
  return null;
}

export const PRESET_COLORS = [
  '#4F46E5', // Indigo
  '#7C3AED', // Violet
  '#2563EB', // Blue
  '#0284C7', // Sky Blue
  '#0891B2', // Cyan
  '#0D9488', // Teal
  '#059669', // Emerald
  '#16A34A', // Green
  '#CA8A04', // Yellow
  '#D97706', // Amber
  '#E11D48', // Rose
  '#DB2777', // Pink
];

export function getRoleBadgeStyles(role) {
  if (!role) return {};

  const defaultColors = {
    pastor_supervisor: '#4F46E5',    // Indigo
    pastor_senior: '#7C3AED',        // Violet
    pastor_rede: '#0891B2',          // Cyan
    discipulador_celula: '#0D9488',  // Teal
    lider_celula: '#059669',         // Emerald/Green
    membro: '#D97706',               // Amber
    frequentador: '#4B5563',         // Slate
    visitante: '#0284C7',            // Sky Blue
    tenant_admin: '#2563EB',         // Blue
  };

  let baseColor = role.color;

  if (!baseColor) {
    if (role.slug && defaultColors[role.slug]) {
      baseColor = defaultColors[role.slug];
    } else {
      const name = role.name || '';
      let hash = 0;
      for (let i = 0; i < name.length; i++) {
        hash = name.charCodeAt(i) + ((hash << 5) - hash);
      }
      // Safe colors for automatic generation (exclui rose e pink)
      const safeColors = [
        '#4F46E5', '#7C3AED', '#0891B2', '#0D9488', 
        '#059669', '#D97706', '#0284C7', '#4B5563', 
        '#2563EB', '#16A34A', '#CA8A04', '#6366F1'
      ];
      const index = Math.abs(hash) % safeColors.length;
      baseColor = safeColors[index];
    }
  }

  const rgb = hexToRgb(baseColor);
  if (!rgb) {
    return {
      backgroundColor: 'var(--primary-light)',
      color: 'var(--primary)',
      border: '1px solid rgba(var(--primary-rgb), 0.2)'
    };
  }

  return {
    backgroundColor: `rgba(${rgb.r}, ${rgb.g}, ${rgb.b}, 0.1)`,
    color: baseColor,
    border: `1px solid rgba(${rgb.r}, ${rgb.g}, ${rgb.b}, 0.2)`
  };
}
